const THREE_HOURS_IN_MILLISECONDS = 3 * 60 * 60 * 1000;

const getProjectionStartDate = (
  projectionDate: Date | string,
  projectionTime: Date | string,
) => {
  const date = new Date(projectionDate);

  if (Number.isNaN(date.getTime())) {
    return undefined;
  }

  const [hours = "0", minutes = "0", seconds = "0"] = projectionTime
    .toString()
    .split(":");

  const projectionStart = new Date(date);
  projectionStart.setHours(
    Number(hours),
    Number(minutes),
    Number(seconds),
    0,
  );

  if (Number.isNaN(projectionStart.getTime())) {
    return undefined;
  }

  return projectionStart;
};

export const isProjectionPurchaseLocked = (
  projectionDate: Date | string,
  projectionTime: Date | string,
  now: Date = new Date(),
) => {
  const projectionStart = getProjectionStartDate(projectionDate, projectionTime);

  if (projectionStart === undefined) {
    return false;
  }

  const isSameDay =
    projectionStart.getFullYear() === now.getFullYear() &&
    projectionStart.getMonth() === now.getMonth() &&
    projectionStart.getDate() === now.getDate();

  return (
    isSameDay &&
    projectionStart.getTime() - now.getTime() <= THREE_HOURS_IN_MILLISECONDS
  );
};
